<template>
  <div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <template v-if="!loading && team">
      <table class="table table-sm table-hover mt-0">
        <thead>
        <tr>
          <th></th>
          <th>Курьер</th>
          <th>дата</th>
          <th>сумма</th>
          <th>комментарий</th>
          <th>
            <label class="mb-0">
              <input type="checkbox" @change="selectIncomes">
              выплатить
            </label>
          </th>
          <th v-if="!actionDisabled"></th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(u,i) in team" v-if="(incomes[u.id] ?? []).length">
          <tr>
            <td :rowspan="(incomes[u.id] ?? []).length + 1">{{ i + 1 }}</td>
            <td :rowspan="(incomes[u.id] ?? []).length + 1">({{ u.id }}) {{ u.name }}</td>
          </tr>
          <template v-if="incomes[u.id]">
            <tr v-for="inc in incomes[u.id]">
              <td>{{ printDate(inc.report_date, 'DD.MM.YYYY') }} ({{ inc.id }})</td>
              <td><strong>{{ inc.sum.toLocaleString('ru-RU') }}</strong></td>
              <td>{{ inc.comment }}</td>
              <td>
                <input type="checkbox" v-model="selectedIncomes[inc.id]">
              </td>
              <td v-if="!actionDisabled">
                <LoadingButton
                  title="игнорировать"
                  type="button"
                  :loading="ignoreBtnLoading[inc.id]"
                  :color="$constants.LOADING_COLOR"
                  :onClick="() => ignoreIncome(u.id, inc)"
                  className="btn btn-sm btn-outline-info"
                />
              </td>
            </tr>
          </template>
        </template>
        </tbody>
      </table>
      <div v-if="Object.keys(agentsToPay).length" class="text-right mr-2">
        <div class="flex justify-content-end">
          <div class="text-left">
            <div v-for="(aSum, id) in agentsToPay" class="fs-18">
              <label class="mb-0">
                <input type="checkbox" disabled v-model="selectedAgents[id]">
                <strong>{{ aSum.sum.toLocaleString('ru-RU') }}</strong>
                {{ +id === agent.id ? agent.name : hardSubAgent[agent.id].name }}
              </label>
            </div>
          </div>
        </div>
        <LoadingButton
          v-if="!actionDisabled"
          title="Выплатить"
          type="button"
          :loading="payLoadingBtn"
          :color="$constants.SUCCESS_COLOR"
          :onClick="() => makePayment()"
          className="mt-1 btn btn-sm btn-outline-success"
        />
      </div>
    </template>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton.vue";

export default {
  components: {LoadingButton},
  props: ['agent'],
  data() {
    return {
      actionDisabled: true,
      team: null,
      hardSubAgent: {
        290: {userId: 291, name: 'Брат'}
      },
      ignoreBtnLoading: {},
      selectedIncomes: {},
      selectedAgents: {},
      incomes: {},
      loading: false,
      payLoadingBtn: false,
      agentsToPay: {}
    }
  },
  created() {
    if (this.$currentRole === 'admin') this.actionDisabled = false;
    this.getTeam();
  },
  watch: {
    'selectedIncomes': {
      handler: function (val, oldVal) {
        this.updatePayments();
      },
      deep: true
    }
  },
  methods: {
    async makePayment() {
      if (!Object.values(this.selectedAgents).find((s) => s)) return;
      this.payLoadingBtn = true;
      const {data} = await api.post('/users/payment', {
        type: 'agent_pay_for_incomes',
        agents_to_pay: this.agentsToPay
      });
      if (data.success) {
        toastr['success']('Сохранено');
        await this.getTeam();
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
      }
      this.payLoadingBtn = false;
    },
    updatePayments() {
      this.agentsToPay = Object.keys(this.incomes).reduce((acc, uId) => {
        const user = this.team.find((t) => t.id === +uId);
        const details = user.details.find((d) => d.alias === 'agent_incomes_percent')?.details ?? [];
        this.incomes[uId].forEach((i) => {
          if (!this.selectedIncomes[i.id]) return;
          details.forEach((d) => {
            if (!d.agent_id) d.agent_id = 0;
            if (!acc[d.agent_id]) acc[d.agent_id] = {sum: 0, incomes: {}};
            const sum = Math.round(+i.sum * +d.percent / 100);
            acc[d.agent_id].sum += sum;
            acc[d.agent_id].incomes[i.id] = sum;
          })
        })
        return acc;
      }, {});
      this.selectedAgents = Object.keys(this.agentsToPay).reduce((acc, u) => {
        acc[u] = true;
        return acc;
      }, {})
    },
    selectIncomes(e) {
      if (!e.target.checked) {
        this.selectedIncomes = {};
      } else {
        this.selectedIncomes = Object.values(this.incomes).reduce((acc, ii) => {
          ii.forEach((i) => {
            acc[i.id] = true;
          })
          return acc;
        }, {})
      }
    },
    async ignoreIncome(userId, income) {
      this.ignoreBtnLoading[income.id] = true;
      this.ignoreBtnLoading = {...this.ignoreBtnLoading};
      const {data} = await api.post('/reports/updateIncome', {
        action: 'ignoreForAgentPayment',
        income_id: income.id,
      });
      if (data.success) {
        this.selectedIncomes[data.record.id] = false;
        this.incomes[userId] = this.incomes[userId].filter((i) => i.id !== data.record.id);
      } else {
        toastr['warning'](data.message || 'нет ответа', 'Ошибка')
      }
      this.ignoreBtnLoading[income.id] = false;
    },
    getIncomePercent(user) {
      const percent = +(user.details.find((d) => d.alias === 'agent_incomes_percent')?.details) ?? 0;
      const sum = (this.incomes[user.id] ?? []).reduce((acc, i) => acc + +i.sum, 0);
      return Math.round(sum * percent / 100);
    },
    async getTeam() {
      this.loading = true;
      this.agentsToPay = {};
      this.selectedAgents = {};
      this.selectedIncomes = {};
      const {data} = await api.index('/users/agents/' + this.agent.id);
      if (data.success) {
        this.incomes = data.incomes.reduce((acc, i) => {
          if (!acc[i.user_id]) acc[i.user_id] = [];
          acc[i.user_id].push(i);
          return acc;
        }, {});
        this.team = data.team;
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
p {
  margin-bottom: 0;
}

.table td, .table th {
  padding: 3px;
}
</style>
